/**
 * Who is talking in the voice channel right now (decision 146), from Discord's speaking start and
 * stop events. Same list back when nothing changed, so the store does not re-render. Pure.
 */
export function withSpeaker(speaking: readonly string[], userId: string, on: boolean): string[] {
  const has = speaking.includes(userId);
  if (on === has) return speaking as string[];
  return on ? [...speaking, userId] : speaking.filter((id) => id !== userId);
}
